exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] #FlexPane_OwaTimePanel{background-color:\"[theme:white, default:#ffffff]\"}#CustomFlexPane_OwaTimePanel>div{height:100%}._2WahQhlBcSPSX2wSnXzmyE{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%}html[dir] ._2WahQhlBcSPSX2wSnXzmyE{background-color:\"[theme:white, default:#ffffff]\";margin-top:-8px}html[dir=ltr] ._2WahQhlBcSPSX2wSnXzmyE,html[dir=rtl] ._2WahQhlBcSPSX2wSnXzmyE{margin-left:-16px;margin-right:-16px}._1ZbK4OTa02wJnVPQ7P53v7{height:calc(100vh - 48px - 65px)}", ""]);

// exports
exports.locals = {
	"container": "_2WahQhlBcSPSX2wSnXzmyE",
	"contentWrapper": "_1ZbK4OTa02wJnVPQ7P53v7"
};